
import React, { useState, useRef }  from 'react';
import Popover                      from '_views/shared/Popover';

import { toClassStr }               from '_utils/UiHelper';


const planOptions = {
  school: {
    id: 1,
    title: 'School',
    details: 'Perfect for teachers, department head, or school administrators',
    redirectUrl: 'https://share.hsforms.com/1qLB8v_qTQS-gNXihGtFriA1fype',
  },
  company: {
    id: 2,
    title: 'Employee Training',
    details: 'Suitable for sharing flashcards with empolyees, clients, or partners',
    redirectUrl: 'https://share.hsforms.com/1nTvQA_8oT82t7-1_dbIy_A1fype',
  },
  publisher: {
    id: 3,
    title: 'E-learning Organization',
    details: 'Great for publishers, authors, or content creators reselling content to their learners',
    redirectUrl: 'https://share.hsforms.com/1erfwLRt-SaeKDazzrFh6ug1fype',
  },
};


const GroupLicensePopover = () => {

  /*
  ==================================================
   HOOKS 
  ==================================================
  */

  const [hovered, setHovered] = useState(false);
  const [activePlanId, setActivePlanId] = useState('school');
  const activePlanDetails = planOptions[activePlanId] || planOptions['school'];
  let hoverTimeout = useRef();


  /*
  ==================================================
   EVENT HANDLERS
  ==================================================
  */

  const handleMouseEnter = () => {
    clearTimeout(hoverTimeout.current);
    setHovered(true);
  };
  
  const handleMouseLeave = () => {
    hoverTimeout.current = setTimeout(() => {
      setHovered(false);
    }, 150);
  };

  const handleClosePopover = () => {
    setHovered(false);
  };

  /*
  ==================================================
   EVENT PUBLISHERS
  ==================================================
  */


  /*
  ==================================================
   EVENT TRIGGERS
  ==================================================
  */


  /*
  ==================================================
   LOCAL UTILS
  ==================================================
  */


  /*
  ==================================================
   SUB RENDERERS
  ==================================================
  */

  /*
  ==================================================
   EXPORTED COMPONENT  
  ==================================================
  */

  const isHovered = hovered ? 'active' : '';
  const classes = toClassStr(['group-license-popover-selector', isHovered]);

  return (
    <div
      className={classes}
      data-plan-id={activePlanId}
      onMouseEnter={() => handleMouseEnter()}
      onMouseLeave={() => handleMouseLeave()}
    >
   
      <p>Request an Estimate</p>

      {hovered && (
        <Popover
          addClasses='group-license-popover'
          activePlan={activePlanId}
          onSelectPlan={setActivePlanId} 
          onClose={handleClosePopover}
          options={planOptions}
          title='Choose a group license form'
          redirectUrl={activePlanDetails.redirectUrl}
        />
      )}
    </div>
  );
};

export default GroupLicensePopover;
